import { StyleSheet, View, Text } from "react-native";

import { getTimestampToDate, parseDivValue, parseKeyValue } from "../../../common/util";
import { FONT } from "../../../value/staticValues";

import { useTranslation } from "react-i18next";
import ContentBox from "../../base/tamplate/ContentBox";
import { ContentContainerProps } from "../../../interfaceTypes/ContentsProps";

import { ReactComponent as TableEditImg } from '../../../img/ico-table-edit.svg';
import { ReactComponent as RedirImg } from '../../../img/ico-prefix-redir.svg';
import { ReactComponent as InfoImg } from '../../../img/ico-msg-info-2.svg';

import { ReactComponent as DeleteImg } from '../../../img/ico-prefix-close-gray.svg';

import { ReactComponent as DeploymentImg} from "../../../img/ico-vpc-list-deployment.svg";

import { ReactComponent as ActiveImg} from "../../../img/ico-account-sleeper.svg";
import { ReactComponent as InactiveImg } from "../../../img/ico-account-idle.svg";

import { ReactComponent as PodImg } from "../../../img/ico-prefix-pod.svg";
import { ReactComponent as PodActiveImg } from "../../../img/ico-prefix-pod.svg";
import { ReactComponent as StatusStableImg} from "../../../img/ico-status-stable.svg";
import { ReactComponent as StatusBlockImg } from "../../../img/ico-status-block.svg";
import { ReactComponent as SearchNoResultImg } from "../../../img/ico-search-no-result.svg";
import { useNavigate } from "react-router-dom";
import { Fragment } from "react";
import { PodDetailData } from "./PodData";

interface PodDetailProps extends ContentContainerProps {
    podData: PodDetailData;
    updateFunction: Function;
    printLogs: Function;

}
export interface KeyValue {
    key: string;
    value: string;
}
export default function PodDetail(props:PodDetailProps) {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <ContentBox title={t("POD_MGMT_DETAIL_TITLE")} subtitle={t("POD_MGMT_DETAIL_SUBTITLE")} infoText={props.infoText} infoError={props.infoError} back={true} >
            <View style={{width: 1100}}>
                <View style={{
                    flexDirection: "row", alignItems: "center", justifyContent: "flex-end"
                }}>
                    <View style={{ flexDirection: "row", alignItems: "center" }}>
                        <Text style={style.dateTitle}>
                            {t("LAST_UPDATE_DATE_TEXT")}
                        </Text>
                        <Text style={style.dateData}>
                            {props.podData?.update_ts ? props.podData.update_ts : ""}
                        </Text>
                    </View>
                    <View style={{ flexDirection: "row", alignItems: "center", marginLeft: 30 }}>
                        <Text style={style.dateTitle}>
                            {t("CREATE_DATE_TEXT")}
                        </Text>
                        <Text style={style.dateData}>
                            {props.podData?.create_ts ? props.podData.create_ts : ""}
                        </Text>
                    </View>
                </View>

                <View>
                    <View style={{...style.boxContainer, height: "auto", minHeight: 550}}>
                        <View style={{flexDirection: "row", alignItems: "center", marginBottom: 50}}>
                            <Text style={style.boxContentTitleName}>
                                {props.podData.pod_name}
                            </Text>
                            <div
                                style={{display: "flex", alignItems: "center", marginLeft: "auto", cursor: "pointer"}}
                                onClick={() => {
                                    props.printLogs();
                                }}
                            >
                                <Text style={{
                                    marginLeft: 2,
                                    fontFamily: FONT.MEDIUM,
                                    fontSize: 12,
                                    color: "#3c5df2"
                                }}>
                                    {t("POD_LOG_TEXT")}
                                </Text>
                            </div>
                            <div
                                style={{display: "flex", alignItems: "center", marginLeft: 20, cursor: "pointer"}}
                                onClick={() => {
                                    props.updateFunction();
                                }}
                            >
                                <TableEditImg/>
                                <Text style={{
                                    marginLeft: 2,
                                    fontFamily: FONT.MEDIUM,
                                    fontSize: 12,
                                    color: "#3c5df2"
                                }}>
                                    {t("INFO_EDIT_TEXT")}
                                </Text>
                            </div>
                        </View>
                        <View style={{flexDirection: "row", marginBottom: 30, height: 54}}>
                            <Text style={style.boxContentHeaderText}>
                                {t("DESCRIPTION_TEXT")}
                            </Text>
                            <Text style={style.boxContentDataText}>
                                {props.podData.pod_description}
                            </Text>
                        </View>
                        <View style={{flexDirection: "row", alignItems: "center"}}>
                            <View style={{width: 490}}>
                                <View style={{flexDirection: "row", marginBottom: 30}}>
                                    <Text style={style.boxContentHeaderText}>
                                        {t("STATUS_TEXT")}
                                    </Text>
                                    <Text style={{...style.boxContentDataText, color: "#3a8344"}}>
                                        {props.podData.pod_phase}
                                    </Text>
                                </View>
                            </View>
                            <View style={{width: 490}}>
                                <View style={{flexDirection: "row", marginBottom: 30}}>
                                    <Text style={{...style.boxContentHeaderText}}>
                                        {t("RESTART_POLICY_TEXT")}
                                    </Text>
                                    <Text style={{...style.boxContentDataText}}>
                                        {props.podData.restart_policy}
                                    </Text>
                                </View>
                            </View>
                        </View>
                        <View style={{flexDirection: "row", alignItems: "center"}}>
                            <View style={{width: 490}}>
                                <View style={{flexDirection: "row", marginBottom: 30}}>
                                    <Text style={style.boxContentHeaderText}>
                                        {t("CLUSTER_TEXT")}
                                    </Text>
                                    <Text style={style.boxContentDataText}>
                                        {props.podData.container_cluster.container_cluster_name}
                                    </Text>
                                </View>
                            </View>
                            <View style={{width: 490}}>
                                <View style={{flexDirection: "row", marginBottom: 30}}>
                                    <Text style={{...style.boxContentHeaderText}}>
                                        {t("NAMESPACE_TEXT")}
                                    </Text>
                                    <Text style={{...style.boxContentDataText, color:"#0853fb"}}>
                                        {props.podData.namespace.namespace_name}
                                    </Text>
                                </View>
                            </View>
                        </View>
                        <View style={{flexDirection: "row", marginBottom: 30}}>
                            <Text style={style.boxContentHeaderText}>
                                {t("PROJECT_TEXT")}
                            </Text>
                            <Text style={style.boxContentDataText}>
                                {props.podData.project.project_name}
                            </Text>
                        </View>
                        <View style={style.boxContentDivLine}></View>
                        <View style={{flexDirection: "row", alignItems: "center"}}>
                            <View style={{width: 490}}>
                                <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                    <Text style={style.boxContentHeaderText}>
                                        {t("NODE_NAME_TEXT")}
                                    </Text>
                                    <Text style={style.boxContentDataText}>
                                        {props.podData.node_name}
                                    </Text>
                                </View>
                            </View>
                            <View style={{width: 490}}>
                                <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                    <Text style={style.boxContentHeaderText}>
                                        {t("POD_IP_ADDRESS_TEXT")}
                                    </Text>
                                    <Text style={style.boxContentDataText}>
                                        {props.podData.pod_ip_address}
                                    </Text>
                                </View>
                            </View>
                        </View>
                        <View style={{flexDirection: "row", alignItems: "center"}}>
                            <View style={{width: 490}}>
                                <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                    <Text style={style.boxContentHeaderText}>
                                        {t("CONTAINER_COUNT_TEXT")}
                                    </Text>
                                    <Text style={style.boxContentDataText}>
                                        {props.podData.container_active_count + '/' + props.podData.container_count}
                                    </Text>
                                </View>
                            </View>
                            <View style={{width: 490}}>
                                <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                                    <Text style={style.boxContentHeaderText}>
                                        {t("VOLUME_COUNT_TEXT")}
                                    </Text>
                                    <Text style={style.boxContentDataText}>
                                        {props.podData.volume_count}
                                    </Text>
                                </View>
                            </View>
                        </View>
                        <View style={{flexDirection: "row", marginBottom: 30}}>
                            <Text style={{...style.boxContentHeaderText, marginTop: 5}}>
                                {t("LABEL_TEXT")}
                            </Text>
                                {
                                    (()=>{
                                        const parsedKeyValues = parseKeyValue(props.podData.labels);
                                        if (parsedKeyValues && parsedKeyValues.length > 0) {
                                            return (
                                                <div>
                                                    {
                                                        parsedKeyValues.map((label, index) => {
                                                            return (
                                                            <div
                                                                key={index + 100}
                                                                style={{
                                                                    display: "flex", alignItems: "center", justifyContent: "center",
                                                                    minWidth: 20, height: 20,
                                                                    paddingLeft: 10, paddingRight: 10,
                                                                    marginRight: 4,
                                                                    borderRadius: 10,
                                                                    backgroundColor: "#e6ebf2",
                                                                    fontFamily: FONT.REGULAR,
                                                                    fontSize: 12,
                                                                    color: "#9ea0a5",
                                                                    marginBottom: 5
                                                                }}>
                                                                {label.key + '=' + label.value}
                                                            </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            )
                                        }
                                        return (
                                            <Text style={style.boxContentDataText}>
                                                {(t("EMPTY_TEXT"))}
                                            </Text>
                                        )
                                    })()
                                }
                        </View>
                        <View style={{flexDirection: "row", marginBottom: 30}}>
                            <Text style={{...style.boxContentHeaderText, marginTop: 5}}>
                                {t("ANNOTATION_TEXT")}
                            </Text>
                                {
                                    (()=>{
                                        const parsedKeyValues = parseKeyValue(props.podData.annotations);
                                        if (parsedKeyValues && parsedKeyValues.length > 0) {
                                            return (
                                                <div>
                                                    {
                                                        parsedKeyValues.map((annotation, index) => {
                                                            return (
                                                            <div
                                                                key={index + 100}
                                                                style={{
                                                                    display: "flex", alignItems: "center", justifyContent: "center",
                                                                    minWidth: 20, height: 20,
                                                                    paddingLeft: 10, paddingRight: 10,
                                                                    marginRight: 4,
                                                                    borderRadius: 10,
                                                                    backgroundColor: "#e6ebf2",
                                                                    fontFamily: FONT.REGULAR,
                                                                    fontSize: 12,
                                                                    color: "#9ea0a5",
                                                                    marginBottom: 5
                                                                }}>
                                                                {annotation.key + '=' + annotation.value}
                                                            </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            )
                                        }
                                        return (
                                            <Text style={style.boxContentDataText}>
                                                {(t("EMPTY_TEXT"))}
                                            </Text>
                                        )
                                    })()
                                }
                        </View>
                        <View style={{...style.innerItemContainer, flexDirection: "column", alignItems:"flex-start"}}>
                            <View style={{flexDirection: "row", alignItems:"center"}}>
                                <Text style={style.innerItemName}>Pod Scheduled</Text>
                                <View style={{ flexDirection: "row", alignItems: "center", width: 80}}>
                                    {
                                        props.podData.pod_scheduled_status_yn ? <StatusStableImg/> : <StatusBlockImg/>
                                    }
                                    <Text style={{
                                        fontFamily: FONT.REGULAR,
                                        fontSize: 12,
                                        color: props.podData.pod_scheduled_status_yn ? "#3a8344" : "#8c8c8c",
                                    }}>
                                        {props.podData.pod_scheduled_status_yn ? "Scheduled" : "No"}
                                    </Text>
                                </View>
                                <Text style={{...style.innerItemText, marginLeft: 30, width: 700, overflow:"hidden"}}>{props.podData.pod_scheduled_status_reason}</Text>
                            </View>
                            <View style={{flexDirection: "row", alignItems:"center"}}>
                                <Text style={style.innerItemName}></Text>
                                <Text style={{...style.innerItemText, width: 700, minHeight: 20, marginTop: 15, marginLeft:110, color: "#8c9299", height: "100%", overflow:"visible"}}>{props.podData.pod_scheduled_status_message}</Text>
                            </View>
                            <View style={style.innerItemDivContainer}></View>
                            <View style={{flexDirection: "row", alignItems:"center"}}>
                                <Text style={style.innerItemName}>Initialized</Text>
                                <View style={{ flexDirection: "row", alignItems: "center", width: 80}}>
                                    {
                                        props.podData.initialized_status_yn ? <StatusStableImg/> : <StatusBlockImg/>
                                    }
                                    <Text style={{
                                        fontFamily: FONT.REGULAR,
                                        fontSize: 12,
                                        color: props.podData.initialized_status_yn ? "#3a8344" : "#8c8c8c",
                                    }}>
                                        {props.podData.initialized_status_yn ? "Initialized" : "No"}
                                    </Text>
                                </View>
                                <Text style={{...style.innerItemText, marginLeft: 30, width: 700, overflow:"hidden"}}>{props.podData.initialized_status_reason}</Text>
                            </View>
                            <View style={{flexDirection: "row", alignItems:"center"}}>
                            <Text style={style.innerItemName}></Text>
                                <Text style={{...style.innerItemText, width: 700, minHeight: 20, marginTop: 15,marginLeft:110, color: "#8c9299", height: "100%", overflow:"visible"}}>{props.podData.initialized_status_message}</Text>
                            </View>
                            <View style={style.innerItemDivContainer}></View>
                            <View style={{flexDirection: "row", alignItems:"center"}}>
                                <Text style={style.innerItemName}>Containers Ready</Text>
                                <View style={{ flexDirection: "row", alignItems: "center", width: 80}}>
                                    {
                                        props.podData.containers_ready_status_yn ? <StatusStableImg/> : <StatusBlockImg/>
                                    }
                                    <Text style={{
                                        fontFamily: FONT.REGULAR,
                                        fontSize: 12,
                                        color: props.podData.containers_ready_status_yn ? "#3a8344" : "#8c8c8c",
                                    }}>
                                        {props.podData.containers_ready_status_yn ? "Ready" : "No"}
                                    </Text>
                                </View>
                                <Text style={{...style.innerItemText, marginLeft: 30, width: 700, overflow:"hidden"}}>{props.podData.containers_ready_status_reason}</Text>
                            </View>
                            <View style={{flexDirection: "row", alignItems:"center"}}>
                            <Text style={style.innerItemName}></Text>
                                <Text style={{...style.innerItemText, width: 700, minHeight: 20, marginTop: 15,marginLeft:110, color: "#8c9299", height: "100%", overflow:"visible"}}>{props.podData.containers_ready_status_message}</Text>
                            </View>
                            <View style={style.innerItemDivContainer}></View>
                            <View style={{flexDirection: "row", alignItems:"center"}}>
                                <Text style={style.innerItemName}>Ready</Text>
                                <View style={{ flexDirection: "row", alignItems: "center", width: 80}}>
                                    {
                                        props.podData.ready_status_yn ? <StatusStableImg/> : <StatusBlockImg/>
                                    }
                                    <Text style={{
                                        fontFamily: FONT.REGULAR,
                                        fontSize: 12,
                                        color: props.podData.ready_status_yn ? "#3a8344" : "#8c8c8c",
                                    }}>
                                        {props.podData.ready_status_yn ? "Ready" : "Down"}
                                    </Text>
                                </View>
                                <Text style={{...style.innerItemText, marginLeft: 30, width: 700, overflow:"hidden"}}>{props.podData.ready_status_reason}</Text>
                            </View>
                            <View style={{flexDirection: "row", alignItems:"center"}}>
                            <Text style={style.innerItemName}></Text>
                                <Text style={{...style.innerItemText, width: 700, minHeight: 20, marginTop: 15,marginLeft:110, color: "#8c9299", height: "100%", overflow:"visible"}}>{props.podData.ready_status_message}</Text>
                            </View>
                        </View>
                    </View>
                    <View style={{...style.boxContainer, minHeight: 250}}>
                        <View style={{flexDirection: "row", alignItems: "flex-end", marginBottom: 30}}>
                            <Text style={{...style.boxContentTitle, width: 120, fontFamily: FONT.REGULAR, color: "#3a3b3f"}}>
                                {t("CONTAINER_LIST_TEXT")}
                            </Text>
                            <Text style={{...style.boxContentTitleDescription}}>
                                {t("MESSAGE_POD_DETAIL_CONTAINER_LSIT_TITLE_DESCRIPTION_MESSAGE")}
                            </Text>
                        </View>
                        {
                            props.podData.pod_containers && props.podData.pod_containers.length > 0 ? props.podData.pod_containers.map((item, index) => {
                                return (
                                    <View key={item.pod_container_name + index.toString()} style={{flexDirection: "row", alignItems: "center"}}>
                                        <View style={{...style.innerItemContainer, flexDirection: "column", alignItems:"flex-start"}}>
                                            <View style={{flexDirection: "row", alignItems:"center"}}>
                                                <Text style={{...style.innerItemName, overflow:"hidden"}}>{item.pod_container_name}</Text>

                                                <Text style={{...style.innerItemName, width:40}}>{t("READY_STATUS_TEXT")}</Text>
                                                <View style={{ flexDirection: "row", alignItems: "center", width: 70}}>
                                                    {
                                                        item.ready_yn ? <StatusStableImg/> : <StatusBlockImg/>
                                                    }
                                                    <Text style={{
                                                        fontFamily: FONT.REGULAR,
                                                        fontSize: 12,
                                                        color: item.ready_yn ? "#3a8344" : "#8c8c8c",
                                                    }}>
                                                        {item.ready_yn ? "Ready" : "No"}
                                                    </Text>
                                                </View>
                                                <Text style={{...style.innerItemName, width:40}}>{t("START_STATUS_TEXT")}</Text>
                                                <View style={{ flexDirection: "row", alignItems: "center", width: 70}}>
                                                    {
                                                        item.start_yn ? <StatusStableImg/> : <StatusBlockImg/>
                                                    }
                                                    <Text style={{
                                                        fontFamily: FONT.REGULAR,
                                                        fontSize: 12,
                                                        color: item.start_yn ? "#3a8344" : "#8c8c8c",
                                                    }}>
                                                        {item.start_yn ? "Started" : "No"}
                                                    </Text>
                                                </View>
                                                <Text style={{...style.innerItemName, width:40}}>{t("RESTART_COUNT_TEXT")}</Text>
                                                <View style={{ flexDirection: "row", alignItems: "center", width: 70}}>
                                                    <Text style={{
                                                        fontFamily: FONT.REGULAR,
                                                        fontSize: 12,
                                                        color:"#0853fb",
                                                    }}>
                                                        {item.restart_count}
                                                    </Text>
                                                </View>
                                                <View style={{...style.innerDataContainer, width: "auto"}}>
                                                    <Text style={{...style.innerItemText, overflow:"hidden"}}>
                                                        {t("IMAGE_NAME_TEXT")}
                                                    </Text>
                                                    <Text style={{...style.innerItemBlueText, width: 330, overflow:"hidden"}} numberOfLines={1}>
                                                        {item.container_image_name}
                                                    </Text>
                                                </View>
                                            </View>
                                            <View style={style.innerItemDivContainer}></View>
                                            <View style={{flexDirection: "row", alignItems:"flex-start", marginTop: 20}}>
                                                <Text style={{...style.innerItemName, overflow:"hidden", color: "#333", fontFamily:FONT.MEDIUM, fontSize: 13}}>{t("STATE_INFO_TEXT")}</Text>
                                            </View>
                                            <View style={{flexDirection: "row", alignItems:"center", marginTop: 20}}>
                                                <Text style={style.innerItemName}>{t("RUNNING_STATE_TEXT")}</Text>
                                                <View style={{ flexDirection: "row", alignItems: "center", width: 80}}>
                                                    {
                                                        item.state_running_start_date ? <StatusStableImg/> : <StatusBlockImg/>
                                                    }
                                                    <Text style={{
                                                        fontFamily: FONT.REGULAR,
                                                        fontSize: 12,
                                                        color: props.podData.pod_scheduled_status_yn ? "#3a8344" : "#8c8c8c",
                                                    }}>
                                                        {item.state_running_start_date ? "Running" : item.state_terminate_finish_date ?  "Terminated" : "Waiting"}
                                                    </Text>
                                                </View>
                                                <Text style={{...style.innerItemText, marginLeft: 30, width: 700, overflow:"hidden"}}>
                                                    {
                                                        item.state_running_start_date ? "Running Start At " + item.state_running_start_date + "." : item.state_terminate_finish_date ? "Terminated Finished At " + item.state_terminate_finish_date + ". " + item.state_terminate_reason : item.state_wait_reason
                                                    }
                                                    </Text>
                                            </View>
                                            {
                                                item.state_running_start_date ? null
                                                :
                                                <View style={{flexDirection: "row", alignItems:"center"}}>
                                                    <Text style={style.innerItemName}></Text>
                                                    <Text style={{...style.innerItemText, width: 700, minHeight: 20, marginTop: 15, marginLeft:110, color: "#8c9299", height: "100%", overflow:"visible"}}>{item.state_wait_message ? item.state_wait_message : item.state_terminate_message}</Text>
                                                </View>
                                            }
                                            <View style={style.innerItemDivContainer}></View>
                                            <View style={{flexDirection: "row", alignItems:"flex-start", marginTop: 20}}>
                                                <Text style={{...style.innerItemName, overflow:"hidden", color: "#333", fontFamily:FONT.MEDIUM, fontSize: 13}}>{t("DETAIL_INFO_TEXT")}</Text>
                                            </View>
                                            <View style={{...style.innerItemContainer, flexDirection:"column", alignItems:"flex-start", marginTop: 20, marginBottom: 10}}>
                                                <View style={{flexDirection: "row", alignItems:"center"}}>
                                                    <Text style={{...style.innerItemName, overflow:"hidden", width: 100}}>
                                                        {t("RESOURCE_TEXT")}
                                                    </Text>
                                                    <View style={{...style.innerDataContainer, width: 750, minHeight: 36}}>
                                                        <Text style={{...style.innerItemText, overflow:"hidden"}}>
                                                            {t("Request CPU")}
                                                        </Text>
                                                        <Text style={Number(item.request_cpu_count) > 0 ? {...style.innerItemResourceValueText} : {...style.innerItemResourceValueText, color:"#333"}}>
                                                            {Number(item.request_cpu_count) > 0 ? item.request_cpu_count : t("EMPTY_TEXT")}
                                                        </Text>
                                                        <Text style={{...style.innerItemText, overflow:"hidden"}}>
                                                            {t("Request Memory")}
                                                        </Text>
                                                        <Text style={item.request_memory_capacity_mb > 0 ? {...style.innerItemResourceValueText, width: 80} : {...style.innerItemResourceValueText, width: 80, color:"#333"}}>
                                                            {item.request_memory_capacity_mb > 0 ? item.request_memory_capacity_mb.toString() + " MB" : t("EMPTY_TEXT")}
                                                        </Text>
                                                        <Text style={{...style.innerItemText, overflow:"hidden"}}>
                                                            {t("Limits CPU")}
                                                        </Text>
                                                        <Text style={Number(item.limit_cpu_count) > 0 ? {...style.innerItemResourceValueText} : {...style.innerItemResourceValueText, color:"#333"}}>
                                                            {Number(item.limit_cpu_count) > 0 ? item.limit_cpu_count : t("EMPTY_TEXT")}
                                                        </Text>
                                                        <Text style={{...style.innerItemText, overflow:"hidden"}}>
                                                            {t("Limits Memory")}
                                                        </Text>
                                                        <Text style={item.limit_memory_capacity_mb > 0 ? {...style.innerItemResourceValueText, width: 80} : {...style.innerItemResourceValueText, width: 80, color:"#333"}}>
                                                            {item.limit_memory_capacity_mb > 0 ? item.limit_memory_capacity_mb.toString() + " MB" : t("EMPTY_TEXT")}
                                                        </Text>
                                                        {
                                                            item.use_gpu_yn ?
                                                            <div style={{display:"flex", alignItems: "center", justifyContent: "center", marginRight: 20,
                                                            width:50, height:20, borderRadius:5, backgroundColor: "#eeecfc", fontFamily: FONT.MEDIUM, fontSize: 12, color:"#806dc6"}}>
                                                                GPU
                                                            </div>:
                                                            <div style={{display:"flex", alignItems: "center", justifyContent: "center", marginRight: 20,
                                                                width:50, height:20, borderRadius:5, fontFamily: FONT.MEDIUM, fontSize: 12, color:"#806dc6"}}>

                                                            </div>
                                                        }
                                                    </View>
                                                </View>

                                                <View style={{flexDirection: "row", alignItems:"flex-start", marginTop: 20}}>
                                                    <Text style={{...style.innerItemName, overflow:"hidden", width: 100, marginTop:5}}>
                                                        {t("VOLUME_MOUNT_INFO_TEXT")}
                                                    </Text>
                                                    <View style={{...style.innerDataContainer, width: 750, minHeight:36, height:"auto"}}>
                                                        {
                                                            (()=>{
                                                                const volumeMounts = parseKeyValue(item.volume_mounts, '=','\n');
                                                                if(volumeMounts.length > 0) {
                                                                    return <View>
                                                                            {
                                                                                volumeMounts.map((mount, index) => {
                                                                                    return <div key={index} style={{display:"flex", alignItems:"center", marginTop: 10, marginBottom: 10}}>
                                                                                        <Text style={{...style.innerItemText, overflow:"hidden", width: 40}}>
                                                                                            {"Name:"}
                                                                                        </Text>
                                                                                        <Text style={{...style.innerItemResourceValueText, width: 100}}>
                                                                                            {mount.key}
                                                                                        </Text>
                                                                                        <Text style={{...style.innerItemText, overflow:"hidden", marginLeft:20, width:75}}>
                                                                                            {"Mount Path:"}
                                                                                        </Text>
                                                                                        <Text style={{...style.innerItemResourceValueText, width: 400, color: "#3a8344"}}>
                                                                                            {mount.value}
                                                                                        </Text>
                                                                                    </div>
                                                                                })
                                                                            }
                                                                        </View>
                                                                }
                                                                return (<Text style={{...style.innerItemResourceValueText, marginLeft: 0, color: "#333", width: 100}}>
                                                                    {t("EMPTY_TEXT")}
                                                                </Text>)
                                                            })()
                                                        }
                                                    </View>
                                                </View>
                                                <View style={{flexDirection: "row", alignItems:"center", marginTop: 20}}>
                                                    <Text style={{...style.innerItemName, overflow:"hidden", width: 100}}>
                                                        {t("CONTAINER_PORT_TEXT")}
                                                    </Text>
                                                    <View style={{...style.innerDataContainer, width: 750, minHeight:36, height:"auto"}}>
                                                        {
                                                            (()=>{
                                                                const ports = parseDivValue(item.ports, ',');
                                                                let portList = "";
                                                                for (let port of ports) {
                                                                    portList += port.toString() + ', ';
                                                                }
                                                                if(ports.length >= 1) {
                                                                    portList = portList.slice(0, -2);
                                                                }

                                                                if(ports.length > 0) {
                                                                    return <View style={{flexDirection:"row", alignItems:"center", marginTop: 10, marginBottom: 10}}>
                                                                            <Text style={{...style.innerItemResourceValueText, marginLeft: 0, color: "#333", width: 500}}>{portList}</Text>
                                                                        </View>
                                                                }
                                                                return (<Text style={{...style.innerItemResourceValueText, marginLeft: 0, color: "#333", width: 100}}>
                                                                    {t("EMPTY_TEXT")}
                                                                </Text>)
                                                            })()
                                                        }
                                                    </View>
                                                </View>
                                                <View style={{flexDirection: "row", alignItems:"flex-start", marginTop: 20}}>
                                                    <Text style={{...style.innerItemName, overflow:"hidden", width: 100, marginTop:5}}>
                                                        {t("ENVIRONMENT_VARIABLE_TEXT")}
                                                    </Text>
                                                    <View style={{...style.innerDataContainer, width: 750, minHeight:36, height:"auto"}}>
                                                        {
                                                            (()=>{
                                                                const envs = parseKeyValue(item.environments, '=','\n');
                                                                if(envs.length > 0) {
                                                                    return <View>
                                                                            {
                                                                                envs.map((env, index) => {
                                                                                    return <div key={index} style={{display:"flex", alignItems:"center", marginTop: 10, marginBottom: 10}}>
                                                                                        <Text style={{...style.innerItemText, overflow:"hidden", width: "auto", color: "#806dc6"}}>
                                                                                            {env.key}{"="}
                                                                                        </Text>
                                                                                        <Text style={{...style.innerItemResourceValueText, marginLeft: 0, width: "auto", color:"#3a8344"}}>
                                                                                            {env.value}
                                                                                        </Text>
                                                                                    </div>
                                                                                })
                                                                            }
                                                                        </View>
                                                                }
                                                                return (<Text style={{...style.innerItemResourceValueText, marginLeft: 0, color: "#333", width: 100}}>
                                                                    {t("EMPTY_TEXT")}
                                                                </Text>)
                                                            })()
                                                        }
                                                    </View>
                                                </View>
                                                <View style={{flexDirection: "row", alignItems:"center", marginTop: 20}}>
                                                    <Text style={{...style.innerItemName, overflow:"hidden", width: 100}}>
                                                        {t("COMMAND_TEXT")}
                                                    </Text>
                                                    <View style={{...style.innerDataContainer, width: 750, minHeight:36, height:"auto"}}>
                                                        {
                                                            (()=>{
                                                                const commands = parseDivValue(item.commands, ',');
                                                                let commandList = "";
                                                                for (let command of commands) {
                                                                    commandList += command.toString() + ', ';
                                                                }
                                                                if(commands.length >= 1) {
                                                                    commandList = commandList.slice(0, -2);
                                                                }

                                                                commandList = "[" + commandList + "]";

                                                                if(commands.length > 0) {
                                                                    return <View style={{flexDirection:"row", alignItems:"center", marginTop: 10, marginBottom: 10}}>
                                                                            <Text style={{...style.innerItemResourceValueText, marginLeft: 0, color: "#333", fontSize: 12, width: 500, overflow:"scroll"}}>{commandList}</Text>
                                                                        </View>
                                                                }
                                                                return (<Text style={{...style.innerItemResourceValueText, marginLeft: 0, color: "#333", width: 100}}>
                                                                    {t("EMPTY_TEXT")}
                                                                </Text>)
                                                            })()
                                                        }
                                                    </View>
                                                </View>
                                                <View style={{flexDirection: "row", marginTop: 20}}>
                                                    <Text style={{...style.innerItemName, overflow:"hidden", width: 100, marginTop: 5}}>
                                                        {t("Liveness Probe")}
                                                    </Text>
                                                    <View style={{...style.innerDataContainer, width: 750, minHeight:36, height:"auto"}}>
                                                        {
                                                            (()=>{
                                                                let commandList = "";
                                                                let httpGetHeaders:KeyValue[] = [];
                                                                let httpGetPort = 0;
                                                                let httpGetPath = "";
                                                                let tcpSocketPort = 0;
                                                                let type = "";

                                                                if(item.liveness_probe_yn) {
                                                                    if(item.liveness_probe_commands) {
                                                                        const commands = parseDivValue(item.liveness_probe_commands, ',');
                                                                        for (let command of commands) {
                                                                            commandList += command.toString() + ', ';
                                                                        }
                                                                        if(commands.length >= 1) {
                                                                            commandList = commandList.slice(0, -2);
                                                                        }

                                                                        commandList = "[" + commandList + "]";
                                                                        type = "COMMAND";
                                                                    } else if(item.liveness_probe_http_get_path && item.liveness_probe_http_get_port > 0) {
                                                                        httpGetHeaders = parseKeyValue(item.liveness_probe_http_get_headers, '=', ',');
                                                                        httpGetPort = item.liveness_probe_http_get_port;
                                                                        httpGetPath = item.liveness_probe_http_get_path;
                                                                        type = "HTTP-GET";
                                                                    } else if(item.liveness_probe_tcp_socket_port > 0) {
                                                                        tcpSocketPort = item.liveness_probe_tcp_socket_port;
                                                                        type = "TCP-SOCKET";
                                                                    } else {
                                                                        item.liveness_probe_yn = false;
                                                                    }
                                                                }
                                                                if(item.liveness_probe_yn) {
                                                                    return <div>
                                                                        <div style={{display:"flex", marginTop: 10, marginBottom: 10}}>
                                                                    <Text style={{...style.innerItemText, overflow:"hidden", width: 30}}>
                                                                        {t("TYPE_TEXT")}
                                                                    </Text>
                                                                    <Text style={{...style.innerItemResourceValueText, width: 120}}>
                                                                        {type}
                                                                    </Text>
                                                                    {
                                                                        type === "COMMAND" ?
                                                                        <Fragment>
                                                                            <Text style={{...style.innerItemText, overflow:"hidden", width: 30}}>
                                                                                {"Exec"}
                                                                            </Text>
                                                                            <Text style={{...style.innerItemResourceValueText, width: 500, fontSize: 12, color: "#333", overflow:"scroll"}}>
                                                                                {commandList}
                                                                            </Text>
                                                                        </Fragment>
                                                                        : type === "HTTP-GET" ?
                                                                        <View>
                                                                            <View style={{flexDirection: "row", alignItems: "center"}}>
                                                                                <Text style={{...style.innerItemText, overflow:"hidden", width: 40}}>
                                                                                    {"Path"}
                                                                                </Text>
                                                                                <Text style={{...style.innerItemResourceValueText, width: 220, fontSize: 12, color: "#3a8344", overflow:"hidden"}}>
                                                                                    {httpGetPath}
                                                                                </Text>
                                                                                <Text style={{...style.innerItemText, overflow:"hidden", width: 40}}>
                                                                                    {"Port"}
                                                                                </Text>
                                                                                <Text style={{...style.innerItemResourceValueText, width: 120, fontSize: 12, color: "#0853fb", overflow:"hidden"}}>
                                                                                    {httpGetPort}
                                                                                </Text>
                                                                            </View>
                                                                            {
                                                                                httpGetHeaders && httpGetHeaders.length > 0 ?
                                                                                <View style={{flexDirection: "row", marginTop: 5}}>
                                                                                    <Text style={{...style.innerItemText, overflow:"hidden", width: 100}}>
                                                                                        {"HTTP Headers"}
                                                                                    </Text>
                                                                                    <View>
                                                                                    {
                                                                                        httpGetHeaders.map((header, index) => {
                                                                                            return <Text key={index} style={{...style.innerItemResourceValueText, width: 400, marginBottom: 3, height:"auto", fontSize: 12, color: "#806dc6"}}>
                                                                                                        {header.key + '=' + header.value}
                                                                                                    </Text>
                                                                                        })
                                                                                    }
                                                                                    </View>
                                                                                </View>
                                                                                : null
                                                                            }
                                                                        </View>
                                                                        : type === "TCP-SOCKET" ?
                                                                        <Fragment>
                                                                            <Text style={{...style.innerItemText, overflow:"hidden", width: 30}}>
                                                                                {"Port"}
                                                                            </Text>
                                                                            <Text style={{...style.innerItemResourceValueText, width: 300, fontSize: 12, color: "#333", overflow:"scroll"}}>
                                                                                {tcpSocketPort}
                                                                            </Text>
                                                                        </Fragment>
                                                                        : null
                                                                    }
                                                                </div>
                                                                    <div style={{display:"flex", marginTop: 10, marginBottom: 10}}>
                                                                        <Text style={{...style.innerItemText, overflow:"hidden", width: 150}}>
                                                                            {"Initial Delay Sec"}
                                                                        </Text>
                                                                        <Text style={{...style.innerItemResourceValueText, width: 120}}>
                                                                            {item.liveness_probe_init_delay_sec + t("SECOND_TEXT")}
                                                                        </Text>
                                                                    </div>
                                                                    <div style={{display:"flex", marginTop: 10, marginBottom: 10}}>
                                                                        <Text style={{...style.innerItemText, overflow:"hidden", width: 150}}>
                                                                            {"Period Sec"}
                                                                        </Text>
                                                                        <Text style={{...style.innerItemResourceValueText, width: 120}}>
                                                                            {item.liveness_probe_period_sec + t("SECOND_TEXT")}
                                                                        </Text>
                                                                    </div>
                                                                    <div style={{display:"flex", marginTop: 10, marginBottom: 10}}>
                                                                        <Text style={{...style.innerItemText, overflow:"hidden", width: 150}}>
                                                                            {"Timeout Sec"}
                                                                        </Text>
                                                                        <Text style={{...style.innerItemResourceValueText, width: 120}}>
                                                                            {item.liveness_probe_timeout_sec + t("SECOND_TEXT")}
                                                                        </Text>
                                                                    </div>
                                                                </div>
                                                                }
                                                                return (<Text style={{...style.innerItemResourceValueText, marginLeft: 0, color: "#333", width: 100}}>
                                                                    {t("EMPTY_TEXT")}
                                                                </Text>)
                                                            })()
                                                        }
                                                    </View>
                                                </View>
                                                <View style={{flexDirection: "row", marginTop: 20}}>
                                                    <Text style={{...style.innerItemName, overflow:"hidden", width: 100, marginTop:5}}>
                                                        {t("Readness Probe")}
                                                    </Text>
                                                    <View style={{...style.innerDataContainer, width: 750, minHeight:36, height:"auto"}}>
                                                        {
                                                            (()=>{
                                                                let commandList = "";
                                                                let httpGetHeaders:KeyValue[] = [];
                                                                let httpGetPort = 0;
                                                                let httpGetPath = "";
                                                                let tcpSocketPort = 0;
                                                                let type = "";

                                                                if(item.readiness_probe_yn) {
                                                                    if(item.readiness_probe_commands) {
                                                                        const commands = parseDivValue(item.readiness_probe_commands, ',');
                                                                        for (let command of commands) {
                                                                            commandList += command.toString() + ', ';
                                                                        }
                                                                        if(commands.length >= 1) {
                                                                            commandList = commandList.slice(0, -2);
                                                                        }

                                                                        commandList = "[" + commandList + "]";
                                                                        type = "COMMAND";
                                                                    } else if(item.readiness_probe_http_get_path && item.readiness_probe_http_get_port > 0) {
                                                                        httpGetHeaders = parseKeyValue(item.readiness_probe_http_get_headers, '=', ',');
                                                                        httpGetPort = item.readiness_probe_http_get_port;
                                                                        httpGetPath = item.readiness_probe_http_get_path;
                                                                        type = "HTTP-GET";
                                                                    } else if(item.readiness_probe_tcp_socket_port > 0) {
                                                                        tcpSocketPort = item.readiness_probe_tcp_socket_port;
                                                                        type = "TCP-SOCKET";
                                                                    } else {
                                                                        item.readiness_probe_yn = false;
                                                                    }
                                                                }
                                                                if(item.readiness_probe_yn) {
                                                                    return <div>
                                                                        <div style={{display:"flex", marginTop: 10, marginBottom: 10}}>
                                                                    <Text style={{...style.innerItemText, overflow:"hidden", width: 30}}>
                                                                        {t("TYPE_TEXT")}
                                                                    </Text>
                                                                    <Text style={{...style.innerItemResourceValueText, width: 120}}>
                                                                        {type}
                                                                    </Text>
                                                                    {
                                                                        type === "COMMAND" ?
                                                                        <Fragment>
                                                                            <Text style={{...style.innerItemText, overflow:"hidden", width: 30}}>
                                                                                {"Exec"}
                                                                            </Text>
                                                                            <Text style={{...style.innerItemResourceValueText, width: 500, fontSize: 12, color: "#333", overflow:"scroll"}}>
                                                                                {commandList}
                                                                            </Text>
                                                                        </Fragment>
                                                                        : type === "HTTP-GET" ?
                                                                        <View>
                                                                            <View style={{flexDirection: "row", alignItems: "center"}}>
                                                                                <Text style={{...style.innerItemText, overflow:"hidden", width: 40}}>
                                                                                    {"Path"}
                                                                                </Text>
                                                                                <Text style={{...style.innerItemResourceValueText, width: 220, fontSize: 12, color: "#3a8344", overflow:"hidden"}}>
                                                                                    {httpGetPath}
                                                                                </Text>
                                                                                <Text style={{...style.innerItemText, overflow:"hidden", width: 40}}>
                                                                                    {"Port"}
                                                                                </Text>
                                                                                <Text style={{...style.innerItemResourceValueText, width: 120, fontSize: 12, color: "#0853fb", overflow:"hidden"}}>
                                                                                    {httpGetPort}
                                                                                </Text>
                                                                            </View>
                                                                            {
                                                                                httpGetHeaders && httpGetHeaders.length > 0 ?
                                                                                <View style={{flexDirection: "row", marginTop: 5}}>
                                                                                    <Text style={{...style.innerItemText, overflow:"hidden", width: 100}}>
                                                                                        {"HTTP Headers"}
                                                                                    </Text>
                                                                                    <View>
                                                                                    {
                                                                                        httpGetHeaders.map((header, index) => {
                                                                                            return <Text key={index} style={{...style.innerItemResourceValueText, width: 400, marginBottom: 3, height:"auto", fontSize: 12, color: "#806dc6"}}>
                                                                                                        {header.key + '=' + header.value}
                                                                                                    </Text>
                                                                                        })
                                                                                    }
                                                                                    </View>
                                                                                </View>
                                                                                : null
                                                                            }
                                                                        </View>
                                                                        : type === "TCP-SOCKET" ?
                                                                        <Fragment>
                                                                            <Text style={{...style.innerItemText, overflow:"hidden", width: 30}}>
                                                                                {"Port"}
                                                                            </Text>
                                                                            <Text style={{...style.innerItemResourceValueText, width: 300, fontSize: 12, color: "#333", overflow:"scroll"}}>
                                                                                {tcpSocketPort}
                                                                            </Text>
                                                                        </Fragment>
                                                                        : null
                                                                    }
                                                                    </div>
                                                                    <div style={{display:"flex", marginTop: 10, marginBottom: 10}}>
                                                                        <Text style={{...style.innerItemText, overflow:"hidden", width: 150}}>
                                                                            {"Initial Delay Sec"}
                                                                        </Text>
                                                                        <Text style={{...style.innerItemResourceValueText, width: 120}}>
                                                                            {item.readiness_probe_init_delay_sec + t("SECOND_TEXT")}
                                                                        </Text>
                                                                    </div>
                                                                    <div style={{display:"flex", marginTop: 10, marginBottom: 10}}>
                                                                        <Text style={{...style.innerItemText, overflow:"hidden", width: 150}}>
                                                                            {"Period Sec"}
                                                                        </Text>
                                                                        <Text style={{...style.innerItemResourceValueText, width: 120}}>
                                                                            {item.readiness_probe_period_sec + t("SECOND_TEXT")}
                                                                        </Text>
                                                                    </div>
                                                                    <div style={{display:"flex", marginTop: 10, marginBottom: 10}}>
                                                                        <Text style={{...style.innerItemText, overflow:"hidden", width: 150}}>
                                                                            {"Timeout Sec"}
                                                                        </Text>
                                                                        <Text style={{...style.innerItemResourceValueText, width: 120}}>
                                                                            {item.readiness_probe_timeout_sec + t("SECOND_TEXT")}
                                                                        </Text>
                                                                    </div>
                                                                </div>
                                                                }
                                                                return (<Text style={{...style.innerItemResourceValueText, marginLeft: 0, color: "#333", width: 100}}>
                                                                    {t("EMPTY_TEXT")}
                                                                </Text>)
                                                            })()
                                                        }
                                                    </View>
                                                </View>
                                            </View>
                                        </View>
                                    </View>
                                    )
                                })
                            :
                            <View style={{flexDirection: "row", alignItems: "center"}}>
                                <View key={99} style={{...style.innerItemContainer, justifyContent:"center"}}>
                                    <SearchNoResultImg style={style.innerItemEmptyImg}/>
                                    <Text style={style.innerItemEmtpyText}>
                                        {t("SEARCH_NO_RESULT_MAIN_TEXT")}
                                    </Text>
                                </View>
                            </View>
                        }
                    </View>
                    <View style={{...style.boxContainer, minHeight: 250}}>
                        <View style={{flexDirection: "row", alignItems: "flex-end", marginBottom: 30}}>
                            <Text style={{...style.boxContentTitle, width: 120, fontFamily: FONT.REGULAR, color: "#3a3b3f"}}>
                                {t("VOLUME_LIST_TEXT")}
                            </Text>
                            <Text style={{...style.boxContentTitleDescription}}>
                                {t("MESSAGE_POD_DETAIL_VOLUME_LSIT_TITLE_DESCRIPTION_MESSAGE")}
                            </Text>
                        </View>
                        {
                            props.podData.pod_volumes && props.podData.pod_volumes.length > 0 ? props.podData.pod_volumes.map((item, index) => {
                                return (
                                    <View key={item.pod_volume_name} style={{flexDirection: "row", alignItems: "center"}}>
                                        <View style={style.innerItemContainer}>
                                            <Text style={{...style.innerItemName, overflow:"hidden"}}>
                                                {
                                                    item.pod_volume_name
                                                }
                                            </Text>
                                            <View style={{...style.innerDataContainer, width:"auto", paddingRight: 20}}>
                                                <Text style={{...style.innerItemBlueText, width: "auto"}}>
                                                    {item.pod_volume_type_code === 'PVC' ? "PVC"
                                                    :item.pod_volume_type_code === 'HOSTPATH' ? "HOST-PATH"
                                                    : "EMPTY-DIR"}
                                                </Text>
                                                {
                                                    item.pod_volume_type_code === 'HOSTPATH' ?
                                                    <View style={{flexDirection: "row", alignItems: "center"}}>
                                                        <Text style={{...style.innerItemText, color: "#3a8344", marginLeft: 15, width: "auto"}}>
                                                            {item.host_path_type_code === "DIR" ? "Directory"
                                                             :item.host_path_type_code === "DIRCRT" ? "Directory Or Create"
                                                             :item.host_path_type_code === "FILE" ? "File"
                                                             :item.host_path_type_code === "FILECRT" ? "File Or Create"
                                                             :item.host_path_type_code === "SOCK" ? "Socket"
                                                             :item.host_path_type_code === "CHDEV" ? "Char Device"
                                                             :"Block Device"}
                                                        </Text>
                                                        <Text style={{...style.innerItemText, marginLeft: 15, width: "auto"}}>
                                                            {item.host_path}
                                                        </Text>
                                                    </View>
                                                    : item.pod_volume_type_code === 'PVC' ?
                                                    <Text style={{...style.innerItemText, marginLeft: 15, width: "auto", color: "#8c8c8c"}}>
                                                        {t("MESSAGE_POD_PROFILE_DETAIL_PVC_DESCRIPTION_MESSAGE")}
                                                    </Text>
                                                    : null
                                                }
                                            </View>
                                        </View>
                                    </View>
                                )
                            })
                            :
                            <View style={{flexDirection: "row", alignItems: "center"}}>
                                <View key={99} style={{...style.innerItemContainer, justifyContent:"center"}}>
                                    <SearchNoResultImg style={style.innerItemEmptyImg}/>
                                    <Text style={style.innerItemEmtpyText}>
                                        {t("SEARCH_NO_RESULT_MAIN_TEXT")}
                                    </Text>
                                </View>
                            </View>
                        }
                    </View>
                </View>
            </View>
        </ContentBox>
    );
}

const style = StyleSheet.create({
    topContainer: {
        width: 1090,
        minHeight: 860,
    },
    boxContainer: {
        marginTop: 20,
        paddingTop: 34, paddingLeft: 50, paddingRight: 40, paddingBottom: 45,
        borderRadius: 8,
        boxShadow: "0 10px 12px 0 rgba(63, 63, 68, 0.05), 0 1px 3px 0 rgba(0, 0, 0, 0.05)",
        borderStyle: "solid", borderWidth: 1, borderColor: "#e5e9ec",
        backgroundColor: "#fff"
    },
    dateTitle: {
        marginRight: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 10,
        color: "#8793a3"
    },
    dateData: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#9ea0a5"
    },
    boxContentTitleName: {
        fontFamily: FONT.BOLD,
        fontSize: 20,
        color: "#494a4d"
    },
    boxContentTitle: {
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        color: "#333"
    },
    boxContentTitleDescription: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#8c8c8c"
    },
    boxContentHeaderText: {
        width: 130,
        marginRight: 52,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        lineHeight: 12,
        color: "#333"
    },
    boxContentDataText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333"
    },
    boxContentDivLine: {
        height: 1,
        border: "solid 0.5px #eee", marginBottom: 30
    },
    innerItemEmtpyText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#4d5367"
    },
    innerItemEmptyImg: {
        width: 50,
        height: 50,
        marginRight: 30,
    },
    settingImg: {
        marginLeft: "auto",
        cursor: "pointer"
    },
    resourceBox: {

    },
    imgBox: {
        alignItems: "center", justifyContent: "center",
        width: 36, height: 36,
        marginRight: 16,
        borderRadius: 10,
        backgroundColor: "rgba(182, 191, 206, 0.3)",
    },
    resourceFixedText: {
        width: 120,
        marginRight: 45,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        lineHeight: 12,
        color: "#333"
    },
    resourceDataText: {
        width: 50,
        fontFamily: FONT.BOLD,
        textAlign: "right",
        fontSize: 14,
        lineHeight: 14,
        color: "#333"
    },
    resourceSubText: {
        width: 40,
        marginLeft: 6,
        fontFamily: FONT.REGULAR,
        fontSize: 11,
        lineHeight: 10,
        color: "#9ea0a5"
    },
    innerItemContainer: {
        flexDirection: "row",
        alignItems: "center",
        width: "100%",
        marginBottom: 30, marginTop: 10, minHeight: 80,
        borderRadius: 10,
        borderStyle: "solid",
        borderWidth: 0.8,
        borderColor: "#d2d5d9",
        paddingLeft: 30,
        paddingRight: 20,
        paddingTop: 20,
        paddingBottom: 20
    },
    innerItemName: {
        marginLeft: 10,
        width: 130,
        height: 20,
        fontSize: 13,
        fontFamily: FONT.REGULAR,
        color: "#333",
        overflow: "hidden",
    },
    innerItemDivContainer: {
        marginTop: 15,
        marginBottom: 20,
        borderBottomColor: "#d2d5d9",
        borderBottomWidth: 0.5,
        width: "100%"
    },
    innerDataContainer: {
        marginLeft: 30,
        flexDirection: "row",
        alignItems: "center",
        width: 200,
        height: 36,
        borderRadius: 10,
        backgroundColor: "#f5f7fa",
        paddingLeft: 20
    },
    innerItemBlueText: {
        width: 120,
        height: 20,
        fontSize: 13,
        fontFamily: FONT.REGULAR,
        color: "#0853fb",
        overflow: "hidden",
    },
    innerItemText: {
        width: 80,
        height: 20,
        fontSize: 13,
        fontFamily: FONT.REGULAR,
        color: "#333",
        overflow: "hidden",
    },
    innerItemResourceValueText: {
        marginLeft: 20,
        paddingRight: 5,
        width: 45,
        height: 20,
        fontSize: 13,
        fontFamily: FONT.REGULAR,
        color: "#0853fb",
        overflow: "hidden",
    },
    innerColumnDivLine: {
        height: 18,
        borderColor: "#d2d5d9",
        borderStyle: "solid",
        borderWidth: 0.8
    },
    innerDataGreenText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#3a8344"
    },
    deploymentImgContainer: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#b6bfce",
        opacity: 0.7,
        borderRadius: 10,
        marginRight: 15
    },
    deploymentImg: {
        opacity: 1
    },
    greenText: {
        color: "#3a8344"
    },
    purpleText: {
        color: "#7066f1"
    },
    blueText: {
        color: "#0853fb"
    }
});